import { Component, Renderer2 } from '@angular/core';
import { LoginResponse, OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from './shared/services/authentification/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'dep-backoffice-spa';



  constructor(
    private renderer: Renderer2
  ) {
    this.renderer.addClass(document.body, 'v2021');
  }

  ngOnInit() {
  }

}
